var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SignatureSave',_vm._b({attrs:{"maxWidth":500,"setTitle":_vm.setTitle,"signatureData":_vm.signatureData,"width":"100%","height":"150px"},on:{"onSignature":(response) => _vm.$emit('onSignature', response)}},'SignatureSave',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }